import type { StylesConfig } from 'react-select'

/**
 * Shared react-select appearance for system settings / forms (zinc + emerald).
 * Works for both single- and multi-select; multi-only parts are ignored for single.
 */
export const hydroReactSelectStyles: StylesConfig<unknown, boolean> = {
    control: (base, state) => ({
        ...base,
        minHeight: 44,
        cursor: 'pointer',
        borderRadius: 8,
        backgroundColor: 'rgb(9 9 11)',
        borderColor: state.isFocused ? 'rgb(16 185 129)' : 'rgb(82 82 91)',
        borderWidth: 1,
        boxShadow: state.isFocused ? '0 0 0 2px rgba(16, 185, 129, 0.35)' : 'none',
        '&:hover': { borderColor: 'rgb(113 113 122)' },
    }),
    valueContainer: (base) => ({ ...base, paddingLeft: 10, paddingRight: 8, paddingTop: 2, paddingBottom: 2 }),
    singleValue: (base) => ({
        ...base,
        color: 'rgb(244 244 245)',
        fontSize: '0.875rem',
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: 'rgb(6 78 59)',
        borderRadius: 6,
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: 'rgb(209 250 229)',
        fontSize: '0.8125rem',
        padding: '2px 6px',
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: 'rgb(167 243 208)',
        ':hover': { backgroundColor: 'rgb(5 46 22)', color: 'rgb(255 255 255)' },
    }),
    input: (base) => ({ ...base, color: 'rgb(250 250 250)' }),
    placeholder: (base) => ({ ...base, color: 'rgb(161 161 170)', fontSize: '0.875rem' }),
    /** In-tree menu (no body portal): stays aligned with the control when the page or a panel scrolls. */
    menu: (base) => ({
        ...base,
        zIndex: 9999,
        backgroundColor: 'rgb(39 39 42)',
        border: '1px solid rgb(63 63 70)',
        borderRadius: 8,
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(0,0,0,0.45)',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menuList: (base) => ({
        ...base,
        maxHeight: 300,
        padding: 6,
    }),
    option: (base, state) => ({
        ...base,
        cursor: 'pointer',
        backgroundColor: state.isSelected
            ? 'rgb(6 78 59)'
            : state.isFocused
              ? 'rgb(63 63 70)'
              : 'transparent',
        color: 'rgb(244 244 245)',
        borderRadius: 6,
        fontSize: '0.875rem',
        marginBottom: 2,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({
        ...base,
        color: 'rgb(161 161 170)',
        padding: 8,
        ':hover': { color: 'rgb(244 244 245)' },
    }),
    clearIndicator: (base) => ({
        ...base,
        color: 'rgb(161 161 170)',
        ':hover': { color: 'rgb(244 244 245)' },
    }),
    container: (base) => ({ ...base, width: '100%' }),
}
